// src/config/api.js
// ─────────────────────────────────────────────────────────────
// Єдине місце для всіх API URL.
// На Vercel — використовуємо відносні URL /api/* (проксі без CORS)
// На основному домені (SITE_URL з config/domain.js) — прямі URL до PHP
// ─────────────────────────────────────────────────────────────

import { SITE_URL } from './domain';

const isVercel = typeof window !== 'undefined' &&
  window.location.hostname.includes('vercel.app');

// На Vercel: /api/... → Vercel proxy → SITE_URL (без CORS)
// На Apache: SITE_URL/api/... (прямо)
const BASE = isVercel ? '' : SITE_URL;

export const API = {
  likes:      `${BASE}/api/likes`,
  otp:        `${BASE}/api/otp`,
  profile:    `${BASE}/api/profile`,
  order:      `${BASE}/api/order`,
  sql:        `${BASE}/api/sql`,
  sqlBrowser: `${BASE}/api/sql-browser`,
  pos:        `${BASE}/api/pos`,
  pdf:        `${BASE}/api/pdf`,
  pdfReport:  `${BASE}/api/pdf-report`,
  prices:     `${BASE}/api/prices`,
  priceList:  `${BASE}/api/price-list`,
  errors:     `${BASE}/api/errors`,
  logs:       `${BASE}/api/logs`,
  invoice:    `${BASE}/api/invoice`,
  cashback:   `${BASE}/api/cashback`,
};
